import React from 'react';
import Icon from '../../../components/AppIcon';

const SchedulePreview = ({ schedules, selectedRoute }) => {
  const generateTimeSlots = () => {
    const slots = [];
    for (let hour = 0; hour < 24; hour++) {
      slots?.push(`${hour?.toString()?.padStart(2, '0')}:00`);
    }
    return slots;
  };

  const timeSlots = generateTimeSlots();

  const getScheduleForTimeSlot = (time) => {
    const [hour] = time?.split(':')?.map(Number);
    
    return schedules?.filter(schedule => {
      if (selectedRoute && schedule?.route_id !== selectedRoute) return false;
      
      const [startHour] = schedule?.start_time?.split(':')?.map(Number);
      const [endHour] = schedule?.end_time?.split(':')?.map(Number);
      
      return hour >= startHour && hour < endHour;
    });
  };

  const hasConflict = (time) => {
    const schedulesAtTime = getScheduleForTimeSlot(time);
    return schedulesAtTime?.length > 1;
  };

  const getTripCount = (time) => {
    const schedulesAtTime = getScheduleForTimeSlot(time);
    if (schedulesAtTime?.length === 0) return 0;

    let totalTrips = 0;
    schedulesAtTime?.forEach(schedule => {
      const [startHour, startMin] = schedule?.start_time?.split(':')?.map(Number);
      const [endHour, endMin] = schedule?.end_time?.split(':')?.map(Number);
      const [slotHour] = time?.split(':')?.map(Number);
      
      const startMinutes = startHour * 60 + startMin;
      const endMinutes = endHour * 60 + endMin;
      const slotMinutes = slotHour * 60;
      
      if (slotMinutes >= startMinutes && slotMinutes < endMinutes) {
        const remainingMinutes = endMinutes - slotMinutes;
        const possibleTrips = Math.floor(remainingMinutes / schedule?.frequency_minutes);
        totalTrips += Math.max(1, possibleTrips);
      }
    });

    return totalTrips;
  };

  const isPeakHour = (time) => {
    const [hour] = time?.split(':')?.map(Number);
    return (hour >= 7 && hour < 10) || (hour >= 17 && hour < 19);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground font-heading">
          Günlük Program Önizleme
        </h3>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-success rounded-sm" />
            <span className="text-xs text-muted-foreground">Normal</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-warning rounded-sm" />
            <span className="text-xs text-muted-foreground">Yoğun</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-error rounded-sm" />
            <span className="text-xs text-muted-foreground">Çakışma</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-6 md:grid-cols-12 gap-2">
        {timeSlots?.map((time) => {
          const tripCount = getTripCount(time);
          const conflict = hasConflict(time);
          const peak = isPeakHour(time);
          
          let bgColor = 'bg-muted';
          if (tripCount > 0) {
            if (conflict) {
              bgColor = 'bg-error/20 border-error';
            } else if (peak) {
              bgColor = 'bg-warning/20 border-warning';
            } else {
              bgColor = 'bg-success/20 border-success';
            }
          }

          return (
            <div
              key={time}
              className={`relative aspect-square rounded-lg border transition-smooth hover:scale-105 ${bgColor}`}
              title={`${time} - ${tripCount} sefer${conflict ? ' (Çakışma!)' : ''}`}
            >
              <div className="absolute inset-0 flex flex-col items-center justify-center p-1">
                <span className="text-xs font-medium text-foreground data-text">
                  {time?.split(':')?.[0]}
                </span>
                {tripCount > 0 && (
                  <span className="text-xs font-bold text-foreground data-text">
                    {tripCount}
                  </span>
                )}
              </div>
              {conflict && (
                <div className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 bg-error rounded-full">
                  <Icon name="AlertTriangle" size={10} color="white" />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-6 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-start gap-3">
          <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg flex-shrink-0 mt-0.5">
            <Icon name="Info" size={16} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground mb-1">
              Program Özeti
            </p>
            <p className="text-xs text-muted-foreground">
              Grafik, seçili rotanın günlük sefer dağılımını gösterir. Her hücre bir saati temsil eder ve içindeki sayı o saatteki tahmini sefer sayısını belirtir. Çakışan programlar kırmızı ile işaretlenir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulePreview;